import { useState } from "react";
import { ButtonOptions, ModalQuestion } from "./ModalQuestion";
import { faCheckCircle, faTrash, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

export const useQuestion = () => {
    const [state, setState] = useState<
        {
            show: boolean;
            message: React.ReactNode;
            title?: React.ReactNode;
            btnConfirmOptions?: ButtonOptions;
            btnCancelOptions: ButtonOptions;
            btnCancelShow: boolean;
            resolve?: (value: boolean) => void
        }>({
            show: false,
            message: "",
            btnConfirmOptions: {
                icon: faTrash,
                title: 'Sim, Remover',
                variant: "danger"
            },
            btnCancelOptions: {
                icon: faXmarkCircle,
                title: 'Não, Cancelar',
                variant: "secondary"
            },
            btnCancelShow: true

        });

    const confirm = (options: {message: React.ReactNode, title?: React.ReactNode, btnConfirmOptions?: ButtonOptions, btnCancelOptions?: ButtonOptions, btnCancelShow?: boolean}): Promise<boolean> => {
        return new Promise((resolve) => {
            setState(prev => (
                {
                    ...prev,
                    show: true,
                    message: options.message,
                    title: options.title,
                    btnConfirmOptions: options.btnConfirmOptions ?? prev.btnConfirmOptions,
                    btnCancelOptions: options.btnCancelOptions ?? prev.btnCancelOptions,
                    btnCancelShow: options.btnCancelShow ?? prev.btnCancelShow,
                    resolve
                }));
        });
    };

    const handleClose = (confirmed: boolean) => {
        if (state.resolve) state.resolve(confirmed);
        setState(
            {
                ...state,
                show: false,
                btnConfirmOptions: { icon: faCheckCircle, title: 'Sim, Remover', variant: 'danger' },
                btnCancelOptions: { icon: faXmarkCircle, title: 'Não, Cancelar', variant: 'secondary' },
            });
    };

    const ConfirmModal = (
        <ModalQuestion
            show={state.show}
            title={state.title}
            message={state.message}
            onClose={handleClose}
            buttonConfirmOptions={state.btnConfirmOptions ?? { icon: faCheckCircle, title: 'Sim, Remover', variant: 'danger' }}
            buttonCancelOptions={state.btnCancelOptions ?? { icon: faXmarkCircle, title: 'Não, Cancelar', variant: 'secondary' }}
            buttonCancelShow={state.btnCancelShow}
        />
    );
    return { confirm, ConfirmModal };
}